import { Outlet } from 'react-router-dom';
import { SiteNav } from '../../navigation/SiteNav';
import { SiteFooter } from '../../navigation/SiteFooter';
import styles from './RootLayout.module.css';

export function RootLayout() {
  return (
    <div className={styles.root}>
      <SiteNav />
      <main className={styles.main}>
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
